import MatchCard from "../../Components/MatchesCard/matchCard"
function Matches() {
    return (
        <>
            <main>
                <MatchCard />
            </main>
        </>
    )
}
export default Matches